import React from 'react'
import Invite from '../../components/Invite/Invite';
import Icon from '../../components/Icon/Icon';
import "./Admin.scss"

const InviteUsers = () => {
    return (
        <div className='container-main'>
            <div className="content-header">
                <div className="header-left">
                    <Icon alias="mail" width={24} height={24} color="#1a1a1a" />
            <h2>Bulk create accounts</h2>
                </div>
                <p className="header-subtitle">Create creator accounts by paste list or CSV upload</p>
            </div>
            <Invite />
        </div>
    )
}

export default InviteUsers